import { Injectable } from '@angular/core';
import { RestService } from '../../core/core/rest.service';
import { Employee, NotificationEmployee } from './employee.model';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';

@Injectable()
export class EmployeesRest {
    constructor(private http: RestService) { }


    public removeEmployee(id: number) {
        return this.http.post(`api/employees/delete/${id}`, {});
    }

    public saveEmployee(employee: Employee, isNew: boolean) {
        return this.http.post(`api/employees/save/${isNew}`, employee);
    }

    public getEmployee(id: number) {
        return this.http.get<Employee>(`api/employees/get/${id}`);
    }

    public getCustomerRows() {
        return this.http.get<ObjectToSelect[]>('api/employees/customers');
    }

    public addCustomerEmployee(customerId: number, employeeId: number) {
        return this.http.post(`api/employees/addCustomerEmployee/${employeeId}/${customerId}`, {});
    }

    public removeCustomerEmployee(customerEmployeeId: number) {
        return this.http.post(`api/customer/removeCustomerEmployee/${customerEmployeeId}`, {});
    }

    public getAvailableSupervisors(employeeId: number) {
        return this.http.get<ObjectToSelect[]>(`api/employees/getAvailableSupervisors/${employeeId}`);
    }

    public removeNotificationEmployee(notificationEmployeeId: number) {
        return this.http.post(`api/employees/removeNotificationEmployee/${notificationEmployeeId}`, {});
    }

    public addNotificationEmployee(notificationEmployeeId: number, employeeId: number){
        return this.http.post<NotificationEmployee>(`api/employees/addNotificationEmployee/${employeeId}/${notificationEmployeeId}`, {});
    }

    public getEmployeeRows(){
        return this.http.get<ObjectToSelect[]>('api/employees/employeeRows');
    }
}
